import { toValue } from "../to-value";
import { print } from "./print";
import { downloadPDF } from "./download-pdf";
import { deleteEditable } from "./editable";
/**
 * 파일명 인자 있을 경우 PDF download, 없을 경우 print
 *
 * @param itemsArr - 아이템 배열
 * @param element - HTMLDivElement
 * @param editableItems - MaybeRef<boolean> | null - 아이템 편집 가능 여부
 * @param fileName - 파일명
 * @param pdfOptions - PDF 옵션 (hasTotalRow 등)
 */
export async function estimatePrintOrPDF(itemsArr, element, editableItems, fileName = null, pdfOptions) {
    try {
        const items = JSON.parse(JSON.stringify(itemsArr));
        items.forEach((modifiedItem) => {
            deleteEditable(modifiedItem);
        });
        const editableRef = editableItems != null ? toValue(editableItems) : null;
        if (editableRef) {
            editableRef.value = !editableRef.value;
        }
        const options = {
            hasTotalRow: true,
            ...pdfOptions,
        };
        if (fileName) {
            await downloadPDF(element, { fileName, ...options });
        }
        else {
            await print(element, options);
        }
        if (editableRef) {
            setTimeout(() => {
                editableRef.value = !editableRef.value;
            }, 1000);
        }
    }
    catch (error) {
        console.error("Error in estimatePrintOrPDF:", error);
        throw error;
    }
}
/** @deprecated costDetailPrintOrPDF 대신 estimatePrintOrPDF을 사용하세요 */
export async function costDetailPrintOrPDF(itemsArr, element, editableItems, fileName = null) {
    return estimatePrintOrPDF(itemsArr, element, editableItems, fileName);
}
